
import {mapActions} from "vuex";

export default {
  name: "toolSoftwaresPop",
  props:['list'],
  data() {
    return {
      jingsaiImg:require('@/assets/imgs/smproapp/jingsai.svg')
    }
  },
  methods:{
    ...mapActions(['setSmproApp']),
    goToPage(link, val, indexChild) {
      this.$parent.menuHide = true;
      if (val === 'zbbs') {
        this.$parent.menuHide = false;
        window.open('/packet-capture');
        return;
      }
      if (val === 'weaknet') {
        this.$parent.menuHide = false;
        window.open('/net-sim');
        return;
      }
      if (val === 'gameping') {
        this.$parent.menuHide = false;
        window.open('/game-sim');
        return;
      }
      if (val) {
        this.setSmproApp(indexChild-1);
      }
      if (location.pathname!==link) {
        this.$router.push({path: link});
      }
      setTimeout(() => {
        this.$parent.menuHide = false;
      }, 100)
    }
  }
}
